/**
 * Add the tracking pixels based on the query string.
 * This file is an adaptation of the existing tracking.js file.
 */

import * as tracking from "./libs/tracking";

(window as any).ACMVisitor = tracking.getACMVisitor();

function loadTrackingPixel(url) {
  if (url) {
    /* To avoid having to include a pixel in the DOM, load the image directly here */
    new Image().src = url;
  }
}

loadTrackingPixel(tracking.getTrackPagePixelUrl());
loadTrackingPixel(tracking.getCookieIdPixelUrl());
